import { useCurrentUser } from "app/current_user/use_current_user";

function useIsOrganizationNameChosen(): boolean {
  const currentUser = useCurrentUser();

  return !!currentUser?.organization.isNameChosen;
}

export default useIsOrganizationNameChosen;
